// Fixture status options
export const getFixtureStatusOptions = (t: (key: string) => string) => [
  { value: 'all', label: t('fixture.statusText.All') },
  { value: 'Active', label: t('fixture.statusText.Active') },
  { value: 'Draft', label: t('fixture.statusText.Draft') },
  { value: 'Inactive', label: t('fixture.statusText.Inactive') },
];

// Legacy constant for backward compatibility
export const FIXTURE_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'Active', label: '启用' },
  { value: 'Draft', label: '草稿' },
  { value: 'Inactive', label: '禁用' },
];

// Fixture action texts - now using function for i18n
export const getFixtureActionTexts = (t: (key: string) => string) => ({
  SEARCH: t('common.search'),
  RESET: t('common.reset'),
  REFRESH: t('common.refresh'),
  CREATE: t('common.add'),
  EDIT: t('common.edit'),
  DELETE: t('common.delete'),
  ENABLE: t('common.enabled'),
  DISABLE: t('common.disabled'),
});

// Legacy constant for backward compatibility
export const FIXTURE_ACTION_TEXTS = {
  SEARCH: '搜索',
  RESET: '重置',
  REFRESH: '刷新',
  CREATE: '新建',
  EDIT: '编辑',
  DELETE: '删除',
  ENABLE: '启用',
  DISABLE: '禁用',
};